import(/* webpackMode: "eager" */ "/codebuild/output/src4286867648/src/github.com/Singularity-DAO/sfi-frontend/apps/dapp/app/capital_manager/page.tsx");
